import { useEffect } from 'react';

export default function useScrollToTop(behavior = 'auto') {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: behavior,
		});
	}, []);
}
